import { useTranslation } from 'react-i18next';
import '../AccountInfo/style.scss';
import { ButtonCTA } from '@src/global/components/UI Elements/ButtonCTA';
import { SUPPORT_URL } from '@global/App/constants/constants';

interface EntitlementAccessButtonProps {
  loading: boolean;
  error: boolean;
  showButton: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
  titleTranslationKeyPrefix?: string;
  withWrapper?: boolean;
  supportButtonLabel?: string;
  showActionButton?: boolean;
}

export const EntitlementButton = ({
  loading,
  error,
  showButton,
  buttonLabel,
  onButtonClick,
  titleTranslationKeyPrefix,
  supportButtonLabel,
  showActionButton = true,
}: EntitlementAccessButtonProps) => {
  const { t } = useTranslation();

  const handleSupportClick = () => {
    window.open(SUPPORT_URL, '_blank');
  };

  return (
    <div className="order-confirmation__account">
      {titleTranslationKeyPrefix && (
        <span className="order-confirmation__account-title">
          {t(
            `${titleTranslationKeyPrefix}.${
              error ? 'error' : loading ? 'loading' : 'loaded'
            }`
          )}
        </span>
      )}

      {error && titleTranslationKeyPrefix && supportButtonLabel && (
        <ButtonCTA
          onClick={handleSupportClick}
          variant="primary"
          className="order-confirmation__account-link"
          aria-label={`${t(supportButtonLabel)} ${t(
            'confirmation.accessibility.opensInNewTab'
          )}`}
        >
          <span className="order-confirmation__account-link-title">
            {t(supportButtonLabel)}
          </span>
        </ButtonCTA>
      )}

      {!error &&
        (loading ? (
          <div
            className="spinner spinner--large"
            role="status"
            aria-label={t('confirmation.accessibility.loadingEntitlements')}
          />
        ) : (
          showButton &&
          showActionButton &&
          buttonLabel &&
          onButtonClick && (
            <ButtonCTA
              onClick={onButtonClick}
              variant="primary"
              className={'order-confirmation__account-link'}
              aria-label={`${t(buttonLabel)} ${t(
                'confirmation.accessibility.opensInNewTab'
              )}`}
            >
              <span className="order-confirmation__account-link-title">
                {t(buttonLabel)}
              </span>
            </ButtonCTA>
          )
        ))}
    </div>
  );
};
